/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CheckboxLabelComponent } from './checkbox-label/checkbox-label.component';
import { CheckboxComponent } from './checkbox.component';
import { PseudoCheckboxComponent } from './pseudo-checkbox/pseudo-checkbox.component';
import { EmptyCheckPipe } from './pseudo-checkbox/empty-check.pipe';

@NgModule({
  declarations: [CheckboxComponent, CheckboxLabelComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    PseudoCheckboxComponent,
    EmptyCheckPipe
  ],
  exports: [CheckboxComponent, CheckboxLabelComponent, PseudoCheckboxComponent]
})
export class CheckboxModule { }
